import { useContext } from "react";
import { HookOutOfContextError } from "@jugl-web/utils";
import { PhoenixSocketContext } from "./PhoenixSocketContext";

export const usePhoenixSocket = () => {
  const context = useContext(PhoenixSocketContext);

  if (!context) {
    throw new HookOutOfContextError("usePheonixSocket", "PhoenixSocketContext");
  }

  return context;
};

export default usePhoenixSocket;
